'use strict';

import React from 'react'

import Loader from '@Pure/Loader'

import Modal  from '@Modal/Modal'

import FormElement from '@/Form/toolkit/FormElement'

import { handleChange } from '@/Form/Functions/eventsHandling'

let app = window.app;

export default class ProviderOrderModal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false,
			data: { },
			form_data: { },
			status_messages: { }
		};

		this.handleClose = this.handleClose.bind(this);
		this.validate    = this.validate.bind(this);
		this.open        = this.open.bind(this);

		this.handleChange = handleChange.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			type: 'listener',
			event: 'open__ProviderOrderModal',
			cb: component.open
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			type: 'listener',
			event: 'open__ProviderOrderModal',
			cb: component.open
		});
	}

	handleClose (e, force)
	{
		const component = this, props = this.props;

		if (component.state.loading === true && !force)
		{
			e.stopPropagation();
			return;
		}

		component.setState(
		{
			open: false,
			loading: false,

			ticket_id: undefined,
			ticket: undefined,
			product: undefined,
			order: undefined,

			form_data: { }
		});
	}

	open (params)
	{
		const component = this, props = this.props;

		let initial_number;

		if (params.ticket)
		{
			initial_number = params.ticket.provider_order || '';
		}
		else
		{
			initial_number = params.number;
		}

		component.setState(
		{
			open : true,

			ticket_id: params.ticket_id,
			ticket: params.ticket,
			product: params.product,
			order: params.order,

			form_data:
			{
				number: initial_number
			}
		});
	}

	validate (e)
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		let data =
		{
			ticket_id: state.ticket_id,
			ticket: state.ticket,
			order: state.order,
			product: state.product,

			number: state.form_data['number']
		};

		if (!state.ticket_id) delete data.ticket;

		qwest.post('/provider-order/update-number', data)
		.then(function (xhr, response)
		{
			app.emit('changedProviderOrder', data);

			component.handleClose(e, true);
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const props = this.props, component = this, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['secondary', 'bg-white'] } />;
		}

		let output =
		(
			<Modal open={ component.state.open } onClose={ component.handleClose }
				title="Saisie d'un numéro de commande" hide_close={ true }>

				<FormElement name="number" type="text" data={ state.form_data }
					onChange={ component.handleChange } label="Numéro de commande"
					status={ state.status_messages }/>

				<div className="c-dialog__buttons">
					<button className="c-btn c-dialog__cancel"
						onClick={ component.handleClose }>
						Annuler
					</button>

					<button className="c-btn c-dialog__danger"
						onClick={ component.validate }>
						Valider
					</button>
				</div>

				{ loader }

			</Modal>
		);

		return output;
	}
}
